import { AppShell } from "@/components/roadmap/app-shell";
import { ErrorBoundary } from "@/components/roadmap/error-boundary";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <>
      <ErrorBoundary>
        <AppShell />
      </ErrorBoundary>
      <Toaster position="bottom-right" theme="light" />
    </>
  );
}
